import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Tabs, Tab, Button } from "react-bootstrap";
import CourseList from '../CreateCourse/CourseList';
import { useLogin } from "../../../context/LoginContext";
import Certificates from "./Certificates";
import { CommanTopBanner, Input, PopupModel } from '../../shared';
import { IC, getLabelbyValue,findValueInArray,isMobileDevice } from '../../../utils/utils';

export default function LoginHome() {
    const navigate = useNavigate();
    const { user, updateUserDetail } = useLogin();
    const [form, setForm] = useState({
        // firstname: '',
        // lastname: '',
        // mobileno: "",
        // emailid: '',
        // state: '',
        // district: '',
        // organization: '',
        // institution: '',
        insurancecompany: '',
        // otherorganization: '',
        // otherinstitution: '',
        // universitycollege: '',
        // role: '',
        // password: "",
        // confirmpassword: "",
        // isMobileVerified: false,
    });
    const [errors, setErrors] = useState({});
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: { msg: '' },
    });
    useEffect(() => {
        if (user.type === "external" && (user.organisation === 'Insurance Company' || user.organisation === '11')) {
            const isvalueinArray = findValueInArray(IC, user.insuranceCompanyName,'label')
            // console.log("🚀 krishna  ~ isvalueinArray:", isvalueinArray);

            // const valueLable = getLabelbyValue(IC, user.insuranceCompanyName, 'value', 'label');
            if (user?.insuranceCompanyName !== '' && isvalueinArray) {
                //
            } else {
                // setForm((prev) => ({ ...prev, 'insurancecompany': '1003' }));
                setPopupData({
                    show: true,
                    title: 'Insurance company verification',
                    type: '',
                    selectedItem: {
                        msg: ''
                    }
                })
            }
        }
        //  console.log(user)
    }, [user]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => {
            const next = {
                ...prev,
                [name]: value,
            };
            return next;
        });
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };
    const hidePupop = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: { msg: '' },
        });
    }
    return (
        <>
            <CommanTopBanner />
            <Col lg={12} className="px-3 courses-viewbg">
                {user?.selectedRole == 'viewer' ?
                    <Row>
                        <Col lg={9}>
                            <Row className="justify-content-between align-items-center mb-1 existing-courselist">
                                <Col lg={12} className='pt-3'>
                                    <Tabs defaultActiveKey="mylearning" id="uncontrolled-tab-example" className="learners-tabsinfo" style={{overflow:'hidden',overflowX:'auto'}}>
                                        <Tab eventKey="mylearning" title="My Learning">
                                            <CourseList showcourse='published' courselearningstatus='all' title="All Courses" />
                                        </Tab>
                                        <Tab eventKey="inprogress" title="In Progress">
                                            <CourseList showcourse='published' courselearningstatus='inprogress' title="All in Progress Courses" />
                                        </Tab>
                                        <Tab eventKey="completed" title="Completed">
                                            <CourseList showcourse='published' courselearningstatus='completed' title="All Completed Courses" />
                                        </Tab>
                                        {isMobileDevice() && (<Tab eventKey="certificate" title="Certificate" >
                                            <Certificates />
                                        </Tab>)}
                                    </Tabs>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={3} className="d-none d-lg-block">
                            <Certificates />
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col lg={12}>
                            <CourseList showcourse='published' courselearningstatus='all' title="All Published Courses" />
                        </Col>
                    </Row>
                }
            </Col>
            {popupData.show ?
                <PopupModel
                    size='md'
                    showModal={popupData.show}
                    handleCloseModal={hidePupop}
                    couldCancel={false}
                    title={popupData.title}
                    type={popupData.type}
                >
                    <Row>
                        <Col md={12} sm={12} className='mb-3'>
                            <Input
                                label="Insurance Company"
                                isMandetory={true}
                                name="insurancecompany"
                                type="select"
                                value={form.insurancecompany}
                                onChange={handleChange}
                                isInvalid={!!errors.insurancecompany}
                                feedback={errors.insurancecompany}
                                inlineFeedback={true}
                                multiple={false}
                                options={IC}
                            />
                        </Col>
                        <Col md={12} sm={12}>
                            <Button
                                variant="warning"
                                type="button"
                                title='Save'
                                className="save-btn"
                                onClick={() => {
                                    updateUserDetail({
                                        "insuranceCompanyCode": form.insurancecompany,
                                        "insuranceCompanyName": getLabelbyValue(IC, form.insurancecompany, 'value', 'label'),
                                        "userId": user.userId
                                    }, () => {
                                        navigate("/");
                                    });
                                }}
                            >
                                Save
                            </Button>
                        </Col>
                    </Row>
                </PopupModel> : null
            }
        </>
    );
}
